import React, { useState } from 'react';
import cn from 'classnames';

import Loader from 'components/Loader';
import { ReactComponent as CaretIcon } from 'assets/imgs/caret-up-empty-black.svg';
import classes from './card.module.scss';
import { ICard } from './types';

const Card: React.FC<ICard> = ({
	className,
	title,
	titleClassName,
	subtitle,
	subtitleClassName,
	onClick,
	children,
	isLoading,
	defaultIsOpen = true,
	withDropDown,
}) => {
	const [isOpen, setIsOpen] = useState(defaultIsOpen);
	const isContentVisible = isOpen || !withDropDown;

	const handleClick = () => {
		if (onClick) {
			onClick();
		}
	};

	const handleToggleIsOpen = () => {
		setIsOpen(!isOpen);
	};

	return (
		<div
			className={cn(classes.card, className, {
				[classes.card__withDropDown]: withDropDown,
				[classes.card__closed]: withDropDown && !isOpen,
			})}
			onClick={handleClick}
		>
			{title && (
				<div
					className={cn(classes.title, titleClassName, {
						[classes.title__withSubtitle]: !!subtitle,
					})}
				>
					{title}
				</div>
			)}
			{withDropDown && (
				<CaretIcon
					className={cn(classes.iconCaret, {
						[classes.iconCaret__closed]: !isOpen,
					})}
					onClick={handleToggleIsOpen}
				/>
			)}
			{subtitle && (
				<div className={cn(classes.subtitle, subtitleClassName)}>
					{subtitle}
				</div>
			)}
			{isLoading ? (
				<Loader
					className={classes.loader}
					itemClassName={classes.loaderItem}
				/>
			) : (
				isContentVisible && children
			)}
		</div>
	);
};

export default Card;
